module.exports = __webpack_public_path__ + "img/workIcon.8aae76d6.png";